import { render, staticRenderFns } from "./ModelOrderDetail.vue?vue&type=template&id=a5a82fd8&"
import script from "./ModelOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ModelOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModelOrderDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports